const SUPABASE_URL_PLACEHOLDER = 'https://your-project-ref.supabase.co'
const SUPABASE_ANON_KEY_PLACEHOLDER = 'your-supabase-anon-key'

const readEnvValue = (value: string | undefined, fallback: string): string => {
  const normalizedValue = value?.trim()
  return normalizedValue && normalizedValue.length > 0 ? normalizedValue : fallback
}

const url = readEnvValue(import.meta.env.VITE_SUPABASE_URL, SUPABASE_URL_PLACEHOLDER)
const anonKey = readEnvValue(import.meta.env.VITE_SUPABASE_ANON_KEY, SUPABASE_ANON_KEY_PLACEHOLDER)

const isUsingPlaceholders =
  url === SUPABASE_URL_PLACEHOLDER || anonKey === SUPABASE_ANON_KEY_PLACEHOLDER

export const supabaseConfig = {
  url,
  anonKey,
  isUsingPlaceholders,
  isConfigured: !isUsingPlaceholders,
}
